class Metj {
  constructor(options) {
    Object.assign(this, options)
  }
}

export default Metj;
